import React from 'react'
import { useTranslation } from 'react-i18next'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import logo from '../../../assets/logo_vertical.svg'
import '../index.less'

import SignupInstructions from '../../../components/authentication/SignupInstructions'

export default function RegisterPage() {
  const { t } = useTranslation()
  return (
    <div className="auth-page">
      <div className="auth-page__logo">
        <img src={logo} alt={t('logo.alt')} />
      </div>
      <SignupInstructions />
    </div>
  )
}
